/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { withTranslation } from "react-i18next";
import styles from "./ReviewSummaryView.module.scss";
import { useSelector } from "react-redux";
import { useEffect } from "react";

const SignatureSummary = ({ t }) => {
  const applicantSignature = useSelector(
    (state) => state.app.applicantSignature
  );
  const otherAdultsInformation = useSelector(
    (state) => state.app.otherAdultsInformation
  );

  const otherAdultsSignature = useSelector(
    (state) => state.app.otherAdultsSignature
  );

  // let otherSignatureArr = [];
  // if (otherAdultsSignature) {
  //   otherSignatureArr = Object.values(otherAdultsSignature);
  // }

  const signatureRef = React.useRef(applicantSignature);
  const otherSignatureRef = React.useRef({});

  const { personalInformation } = useSelector((state) => state.app);
  const { firstName, lastName } = personalInformation;
  const otherAdultName =
    otherAdultsInformation?.length > 0 && otherAdultsInformation[0].firstName;

  useEffect(() => {
    if (!applicantSignature) return;
    const image = new Image();
    image.onload = () => {
      const canvas = signatureRef.current;
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
    };
    image.src = applicantSignature;
  }, [applicantSignature]);

  useEffect(() => {
    if (otherAdultsSignature) {
      if (
        Object.keys(otherAdultsSignature).length > 0 &&
        Object.keys(otherSignatureRef?.current).length > 0
      ) {
        for (const key in otherAdultsSignature) {
          if (Object.hasOwnProperty.call(otherAdultsSignature, key)) {
            const signData = otherAdultsSignature[key];
            const image = new Image();
            image.onload = () => {
              const otherCanvas = otherSignatureRef.current[key];
              const ctx = otherCanvas?.getContext("2d");
              ctx?.clearRect(0, 0, otherCanvas?.width, otherCanvas?.height);
              ctx?.drawImage(image, 0, 0, otherCanvas?.width, otherCanvas?.height);
            };
            image.src = signData;
          }
        }
      }
    }
  }, [otherSignatureRef, otherAdultsSignature]);

  return (
    <div className="row">
      <div className="col-xs-12 col-lg-9">
        <div className="col-xs-12">
          <div className="row" style={{ display: "flex", flexGrow: 1 }}>
            <div
              style={{
                display: "flex",
                flexGrow: 1,
                justifyContent: "space-between",
                alignItems: "center"
              }}
            >
              {/* <div className="col-xs-8 col-md-4">
                <h3>{t("review_summary.signature")}</h3>
              </div>
              <div className="col-xs-4 col-md-8">
                <a
                  id="edit-another-adult"
                  href="#"
                  className={[styles["edit_button"]].join(" ")}
                  onClick={editSignatureOnClick}
                  value={t("shared.edit")}
                  name={t("shared.edit")}
                >
                  <i
                    aria-label={t("shared.edit")}
                    className="fa fa-pencil-alt"
                    aria-hidden="true"
                  ></i>
                  {t("shared.edit")}
                </a>
              </div> */}
            </div>
          </div>

          <div className="row" style={{ display: "flex", flexGrow: 1 }}>
            {/* {signatureRef && (
                            <div>
                                <h2>Signature Image:</h2>
                                <img
                                    src={applicantSignature}
                                    alt="Captured Signature" />
                            </div>
                        )} */}
          </div>
          <div
            className="col-xs-12"
            style={{
              marginTop: "10px",
              display: "flex",
              justifyContent: "space-between"
            }}
          >
            <strong>
              {t("review_summary.signature_of")} {firstName} {lastName}
            </strong>
            <div
              className="col-xs-4"
              style={{
                // backgroundColor: "#EEEEEE",
                alignContent: "center",
                width: "100%",
                maxWidth: 600,
                padding: 0
              }}
            >
              <canvas
                id="canvas"
                ref={signatureRef}
                // penColor="black"
                // backgroundColor="#EEEEEE"
                style={{ width: "100%", height: 100 }}
              // canvasProps={{ width: 600, height: 100, className: 'signature-canvas', background: "#EEEEEE", border: 'solid 1px' }}
              />
              {/* <hr
                style={{
                  width: "80%",
                  border: "solid 1px black",
                  paddingTop: 0,
                  marginTop: 0
                }}
              ></hr> */}
            </div>
          </div>
          <hr className={[styles["hr_100"]].join(" ")} />
          {otherAdultName &&
            otherAdultName?.length > 0 &&
            otherAdultsInformation.map((adult, i) => {
              return (
                <>
                  <div
                    key={adult.localId}
                    className="col-xs-12"
                    style={{
                      marginTop: "10px",
                      display: "flex",
                      justifyContent: "space-between"
                    }}
                  >
                    <strong>
                      {t("review_summary.signature_of")}{" "}
                      {adult.firstName + " " + adult.lastName}
                    </strong>
                    <div
                      className="col-xs-4"
                      style={{
                        // backgroundColor: "#EEEEEE",
                        alignContent: "center",
                        width: "100%",
                        maxWidth: 600,
                        padding: 0
                      }}
                    >
                      <canvas
                        id={"coApplicantcanvas" + adult.localId}
                        ref={(el) =>
                          (otherSignatureRef.current[adult.localId] = el)
                        }
                        // penColor="black"
                        // backgroundColor="#EEEEEE"
                        style={{ width: "100%", height: 100 }}
                      />
                      {/* <hr
                      style={{
                        width: "80%",
                        border: "solid 1px black",
                        paddingTop: 0,
                        marginTop: 0
                      }}
                    ></hr> */}
                    </div>
                  </div>

                  <hr className={[styles["hr_100"]].join(" ")} />
                </>
              );
            })}
          {/* <hr className={[styles["hr_100"]].join(" ")} /> */}
        </div>
      </div>
    </div>
  );
};

export default withTranslation("common")(SignatureSummary);
